module.exports = __webpack_public_path__ + "static/img/wjtb_xls.90fb5da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wjtb_xls.png
// module id = B1uU
// module chunks = 200